import { DocumentItem, FolderResponse } from '../documents-response.model';

export interface BgcMemberPageData {
  memberDetail: BgcMemberDetail | null;
  bgcDocuments: DocumentItem[];
  memberDocumentFolder: FolderResponse | null;
  userCSN: string;
  documentsLoading: boolean;
  documentsLoadFailed: boolean;
}

export class BgcMemberDetailRequest {
  body = {
    ProcessName: 'DC Get BGC Member Details WF',
    'DC Channel': 'Online',
    'DC Method': 'Amendment Page',
    'Account Id': '1-5V4E17F',
    'DCLanguage':'ENU',
    CSN: ''
  };
}

export type BgcMemberDetail = Record<string, unknown>;

export interface BgcMemberDetailResponse {
  'Error Code'?: string | null;
  'Error Message'?: string | null;
  SiebelMessage?: {
    'DC BGC Member Details'?: BgcMemberDetail;
  };
}
